import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { UntypedFormBuilder, UntypedFormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { UtilService } from 'src/app/services/util.service';
import { BusinessCardComponent } from 'src/app/components/cards/business-card/business-card.component';
import { WidgetModule } from 'src/app/widget/widget.module';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NodataFoundComponent } from 'src/app/widget/nodata-found/nodata-found.component';


@Component({
  selector: 'app-business-user',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, ReactiveFormsModule, FormsModule,
BusinessCardComponent, WidgetModule,
    NG_ICON_DIRECTIVES, CommonSkeletonComponent, InfiniteScrollModule,
    NodataFoundComponent,
  ],
  templateUrl: './business-user.component.html',
  styleUrls: ['./business-user.component.scss']
})
export class BusinessUserComponent implements OnInit, OnDestroy {

  BuninessPageData: any;
  businessPages: any[] = [];
  users
  communityPages
  term
  photoId

  isAdmin

  businessData = true;
  businessData1 = false;

  // Inline skeleton grid while a results fetch is in flight (replaces the global
  // spinner for these loads).
  isLoading = false;
  loaderCards = new Array(6);

  // Window infinite scroll with OFFSET paging. The cursor form this replaced sent
  // the last card's sort values back, and the first of those is the relevance
  // score - a float that travels as a JSON number and returns as a double that is
  // not bit-for-bit the original. Rows sharing the cursor's score were then served
  // again, so a page could repeat the whole group it ended on and the list ran
  // past its own total with duplicates. pageIndex * pageSize is an integer, so
  // there is nothing to round.
  pageSize = 15;
  businessTotalCount = 0;
  /** Rows the server has sent for the current search, which is what the next
   *  request offsets by. Kept separate from businessPages.length because
   *  duplicates are now discarded on append. */
  private receivedCount = 0;
  endReached = false;
  isLoadingMore = false;
  loadMoreCards = new Array(3);
  // The text the current list was fetched with (route term or the page's own
  // search box), so scrolling keeps paging the same result set.
  activeSearch = '';

 
  title:string = "Starter";
  Arraylength

  navaData;
  srarch;
  name;

  colors: Array<any> = ['hgreen', 'hred', 'horange', 'hyellow'];
  selColor: string;

  constructor(
    private API: ApiService,
    private fb: UntypedFormBuilder,
    private router: Router ,
    private route: ActivatedRoute,
    private util: UtilService
   // private BusinessComponent: BusinessComponent,
  ) { }

  randomColor(): void {
    this.selColor = this.colors[Math.floor(Math.random() * this.colors.length)];
  }

  /** Closed in ngOnDestroy so the queryParams subscription dies with the
   *  component. The tabs are swapped with *ngIf, so leaving it open kept every
   *  previously-mounted instance alive and re-running its own search on the next
   *  param change - extra in-flight calls the visible component's isLoadingMore
   *  guard cannot see, because that flag is per instance. */
  private readonly destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((data)=>{
      ////// console.log('datanav',data)
      this.navaData =data.data;
      // Trimmed on the way in too: the nav bar already trims, but a bookmarked or
      // hand-edited URL can still carry a whitespace-only searchData.
      this.srarch = (data.searchData ?? '').trim();
      // this.name = data.searchData

    });
    // this.dataBusiness();
    if(this.navaData!= 'undefined' && this.srarch != 'undefined' || this.srarch!=' '){

      this.dataBusiness();
    }else{
      // this.BusinessUserData();
      this.dataBusiness();

    }

  }

  BusinessUserData(){
    const data = {'search': this.srarch,
    'searchContent':'ALL',
    // 'searchContent': 'BUSINESS',
    'loginUserId':localStorage.getItem('userId'),
    'page': {
            'offSet': 0,
            'pageCount': 50
            }
    };
 this.util.startLoader()
    this.API.create('home/profiles/searchAll' , data).subscribe(res => {
      this.util.stopLoader()
    this.dynamicdata= res;
    this.businessPages=res.businessPages;
    this.Arraylength =  res.businessPages.length
    ////// console.log('bData=>>>', this.businessPages)
    ////// console.log('companyLocationDetails', res.businessPage.companyLocationDetails.address1)
    this.businessPages.forEach(element => {
      element.businessLogo = AppSettings.photoUrl+ element.businessLogo;
      element.businessColor = this.colors[Math.floor(Math.random() * this.colors.length)];

     });
     ////// console.log("sBusiness search data:=>>>>",this.businessPages)
     //////// console.log('Array length is :===>>', this.Arraylength)
    },err => {
      this.util.stopLoader();

     });


   }

   dataBusiness(){
    this.activeSearch = this.srarch;
    this.fetchPage(this.pageSize, true);
   }

   get hasMore(): boolean {
    // Measured against rows RECEIVED, not rows kept: a page discarded entirely as
    // duplicate still consumed its slice of the total, and testing the kept
    // length would leave hasMore permanently true.
    return !this.endReached && this.receivedCount < this.businessTotalCount;
   }

   /**
    * Append `incoming` to `existing`, skipping any row whose id is already on
    * screen. Two requests in flight at once return overlapping slices and the
    * server re-ranks between them, so `concat` rendered the same card twice.
    * Rows with no id are kept - they cannot be compared, and dropping them would
    * lose data rather than a duplicate.
    */
   private appendUnique(existing: any[], incoming: any[], idKey: string): any[] {
    if (!incoming || incoming.length === 0) {
      return existing;
    }
    const seen = new Set((existing || []).map(row => row?.[idKey]).filter(id => id != null));
    const fresh = incoming.filter(row => {
      const id = row?.[idKey];
      if (id == null) { return true; }
      if (seen.has(id)) { return false; }
      seen.add(id);
      return true;
    });
    return fresh.length ? (existing || []).concat(fresh) : (existing || []);
   }

   // One request against /home/profiles/search. reset=true starts from the top
   // (first page / new search) and replaces the list, otherwise the next block of
   // pageCount rows is appended.
   private fetchPage(pageCount: number, reset: boolean) {
    // Rows RECEIVED so far IS the offset for the next block. This cannot be
    // businessPages.length any more: the append below drops rows already on
    // screen, so a fully duplicated page would leave the length unchanged, the
    // next request would ask for the same offset, and the feed would loop on one
    // page for ever.
    const offSet = reset ? 0 : this.receivedCount;
    const data = {'search': this.activeSearch,
    'searchContent':'ALL',
    'loginUserId':localStorage.getItem('userId'),
    'page': {
            'offSet': offSet,
            'pageCount': pageCount
            }
    };
    if (reset) {
      this.isLoading = true;
      this.endReached = false;
    } else {
      this.isLoadingMore = true;
    }
    this.API.create('home/profiles/search', data).subscribe(res => {
      this.isLoading = false;
      this.isLoadingMore = false;
      const pages = (res && Array.isArray(res.businessPages)) ? res.businessPages : [];
      pages.forEach(element => {
        // Leave businessLogo as returned: app-business-card prefixes the
        // download URL itself when a logo exists. Prefixing here turned a
        // missing logo into ".../download/undefined", which the browser then
        // requested for every logo-less business before falling back.
        element.businessColor = this.colors[Math.floor(Math.random() * this.colors.length)];
      });
      if (pages.length === 0) {
        this.endReached = true;
      }
      this.businessTotalCount = res?.page?.businessTotalCount ?? pages.length;
      this.receivedCount = offSet + pages.length;
      this.businessPages = reset ? pages : this.appendUnique(this.businessPages, pages, 'businessId');
      // Header count: total matches, not just the cards fetched so far.
      this.Arraylength = this.businessTotalCount;
      this.fillViewportIfNeeded();
    }, err => {
      this.isLoading = false;
      this.isLoadingMore = false;
    });
   }

   // Fires from the infiniteScroll directive when the window nears the bottom.
   onScroll() {
    if (this.isLoading || this.isLoadingMore || !this.hasMore) {
      return;
    }
    this.fetchPage(this.pageSize, false);
   }

   // On a tall screen one page may not produce a scrollbar, and without a
   // scroll event the directive never fires. After each page renders, pull the
   // next one while the document is still shorter than the window.
   private fillViewportIfNeeded() {
    setTimeout(() => {
      if (this.hasMore && document.documentElement.scrollHeight <= window.innerHeight + 50) {
        this.onScroll();
      }
    }, 0);
   }

   // After follow / unfollow refetch everything already on screen in one
   // request so the user keeps their place instead of dropping back to page 1.
   // The returned key then continues from the last card.
   private refreshLoaded() {
    this.fetchPage(Math.max(this.pageSize, this.businessPages.length), true);
   }
  dynamicdata(arg0: string, dynamicdata: any) {
    throw new Error("Method not implemented.");
  }

  connetedstatus(data){

  }

  removedata(data){

  }

  businessLink(data){
    ////// console.log('business data :.....',data)
   var data1: any= {}
   data1.businessId = data.businessId
    this.router.navigate(['business'],{queryParams: data1})
  }

  clearInput = new UntypedFormControl();

  clearData(){
    this.businessData = true;
    this.clearInput.reset();
  ////// console.log('cleare Data')
  }

  businessDataSearch(busn){
    //this.businessData1 = true;
    // Spaces are not a term. Trimming turns "   " back into "" - the same state
    // the box was already in - so the equality check below drops the keystroke
    // instead of refetching the whole list for whitespace.
    const term = (this.clearInput.value ?? '').trim();
    if (term === this.activeSearch) {
      return;
    }
    this.activeSearch = term;
    this.fetchPage(this.pageSize, true);
  }



  addfollower(data,flag) {
    const datas: any = {};
    datas.businessId =data.businessId ;
    datas.userId =localStorage.getItem('userId') ;
    this.util.startLoader()
    this.API.create('business/add/follower',datas).subscribe(res => {
    this.util.stopLoader()
    this.refreshLoaded()
  },err => {
    this.util.stopLoader();

   });

 }

removefollower(data,flag) {
  const datas: any = {};
  datas.businessId =data.businessId ;
  datas.userId =localStorage.getItem('userId') ;
  this.util.startLoader()
  this.API.create('business/revoke/follower',datas ).subscribe(res => {
  this.util.stopLoader()
  this.refreshLoaded()
},err => {
  this.util.stopLoader();

 });

}




}


